import { createSelector } from 'reselect'

const getRemote = (state, key) => state.remote[key] || {}

export const makeGetRemote = () => (
  createSelector([getRemote], (remote) => remote)
)
